import { useEffect, useState } from 'react';

export default function useAuthStatus() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem('user_token')
  );

  useEffect(() => {
    const syncAuth = () => {
      setIsAuthenticated(!!localStorage.getItem('user_token'));
    };

    window.addEventListener('storage', syncAuth);
    return () => window.removeEventListener('storage', syncAuth);
  }, []);

  return isAuthenticated;
}
